import type { Step } from "react-joyride";

export const trainingHubTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ສູນການຝຶກອົບຮົມ ແລະ ມາດຕະຖານ. ທ່ານສາມາດເຂົ້າເຖິງ SOP, Flow, ມາດຕະຖານບໍລິການ, Checklist ແລະ KPI ຂອງທ່ານໄດ້ຈາກບ່ອນນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-hub-cards"]',
    content: "ປຸ່ມເຂົ້າແຕ່ລະພາກສ່ວນ. ກົດເພື່ອເປີດລາຍການ ຫຼື ໜ້າທີ່ກ່ຽວຂ້ອງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-hub-progress"]',
    content: "ສະແດງຄວາມຄືບໜ້າລາຍການກວດສອບໂດຍຫຍໍ້.",
    placement: "top",
  },
];

export const sopListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ນີ້ແມ່ນໜ້າລາຍການຂັ້ນຕອນການດຳເນີນງານ (SOP). ຄົ້ນຫາ, ຈັດລຳດັບ, ແບ່ງໜ້າ ແລະ ກົດກາດເພື່ອເປີດລາຍລະອຽດ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-sop-list-search"]',
    content:
      "ຄົ້ນຫາ SOP ຕາມຫົວຂໍ້, ຈຸດປະສົງ ຫຼື ພະແນກ; ເບິ່ງຈຳນວນລາຍການ; ແຖວລຸ່ມຈັດລຳດັບ ແລະ ທິດການລຽງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-sop-list-grid"]',
    content:
      "ກາດແຕ່ລະລາຍການເພື່ອເປີດ SOP. ມີຫຼາຍກວ່າ 12 ລາຍການໃຊ້ແບ່ງໜ້າດ້ານລຸ່ມ.",
    placement: "top",
  },
];

export const flowListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ນີ້ແມ່ນໜ້າລາຍການແຜນ Flow ການເຮັດວຽກ. ຄົ້ນຫາ, ຈັດລຳດັບ, ແບ່ງໜ້າ ແລະ ກົດກາດເພື່ອເປີດ Flow.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-flow-list-note"]',
    content: "ໝາຍເຫດກ່ຽວກັບຂໍ້ມູນທີ່ສະແດງໃນໜ້ານີ້ (ຖ້າມີ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-flow-list-search"]',
    content:
      "ຄົ້ນຫາ Flow ຕາມຫົວຂໍ້, ລາຍລະອຽດ ຫຼື ພະແນກ; ຈຳນວນລາຍການ; ຈັດລຳດັບ ແລະ ທິດການລຽງແຖວລຸ່ມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-flow-list-grid"]',
    content: "ກາດແຕ່ລະ Flow ເພື່ອເປີດຜັງ ແລະ ລາຍລະອຽດ. ຫຼາຍກວ່າ 12 ລາຍການໃຊ້ແບ່ງໜ້າ.",
    placement: "top",
  },
];

export const serviceStandardListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ນີ້ແມ່ນໜ້າມາດຕະຖານບໍລິການ. ຄົ້ນຫາ, ຈັດລຳດັບ, ແບ່ງໜ້າ ແລະ ກົດກາດເພື່ອອ່ານລາຍລະອຽດ ແລະ ຕົວຢ່າງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-standard-list-search"]',
    content:
      "ຄົ້ນຫາມາດຕະຖານຕາມຊື່, ລາຍລະອຽດ ຫຼື ຊ່ວງບໍລິການ; ຈຳນວນລາຍການ; ຈັດລຳດັບ ແລະ ທິດການລຽງແຖວລຸ່ມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-standard-list-grid"]',
    content: "ກາດແຕ່ລະມາດຕະຖານເພື່ອເປີດລາຍລະອຽດ. ຫຼາຍກວ່າ 12 ລາຍການໃຊ້ແບ່ງໜ້າ.",
    placement: "top",
  },
];

export const checklistListTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າລາຍການກວດສອບທີ່ມອບໝາຍໃຫ້ທ່ານ. ກວດສະຖານະ ແລະ ເປີດແຕ່ລະລາຍການເພື່ອກວດເຄື່ອງຫມາຍລາຍການ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-checklist-list-note"]',
    content: "ໝາຍເຫດກ່ຽວກັບຂໍ້ມູນສະຖານະ ແລະ ວັນຄົບກຳນົດ (ຖ້າມີ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-checklist-list-search"]',
    content: "ຄົ້ນຫາຕາມຫົວຂໍ້, ລາຍລະອຽດ ຫຼື ສະຖານະ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-checklist-list-table"]',
    content: "ກົດແຕ່ລະກາດເພື່ອເປີດໜ້າກວດລາຍການໃນທີ່ດຽວກັນ.",
    placement: "top",
  },
];

export const myKpiTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າ KPI ຂອງທ່ານ. ເບິ່ງເປົ້າໝາຍ, ຄ່າຈິງ, ຮອບວັດແທກ ແລະ ສະຖານະ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-kpi-list-note"]',
    content: "ໝາຍເຫດກ່ຽວກັບກຣາບ ຫຼື ຂໍ້ມູນເພີ່ມເຕີມທີ່ອາດມີໃນອະນາຄົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-kpi-list-search"]',
    content: "ຄົ້ນຫາ KPI ຕາມຊື່, ຮອບ ຫຼື ສະຖານະ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-kpi-list-table"]',
    content: "ຕາຕະລາງ KPI ຂອງທ່ານ.",
    placement: "top",
  },
];

export const flowDetailTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າລາຍລະອຽດ Flow. ທ່ານສາມາດອ່ານຂໍ້ມູນຢູ່ຊ້າຍ (ເມື່ອບໍ່ໄດ້ເລືອກຂັ້ນຕອນ), ເບິ່ງຜັງ ແລະ ກົດຂັ້ນຕອນເພື່ອເບິ່ງລາຍລະອຽດ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-flow-detail-title"]',
    content: "ຊື່ ແລະ ຄຳອະທິບາຍສັ້ນໆຂອງ Flow.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-flow-detail-canvas"]',
    content: "ຜັງ Flow. ກົດຂັ້ນຕອນເພື່ອເບິ່ງລາຍລະອຽດ.",
    placement: "top",
  },
];

export const sopDetailTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າລາຍລະອຽດ SOP. ອ່ານຈຸດປະສົງ, ຂອບເຂດ ແລະ ຂັ້ນຕອນການປະຕິບັດ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-sop-detail-toolbar"]',
    content: "ກັບໄປລາຍການ ຫຼື ເປີດຕົວຢ່າງ PDF ສຳລັບການພິມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-sop-detail-page-title"]',
    content: "ຫົວຂໍ້ SOP ທີ່ທ່ານກຳລັງເບິ່ງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-sop-detail-content"]',
    content: "ເນື້ອຫາ SOP: ຫົວຂໍ້, ຂັ້ນຕອນ ແລະ ເອກະສານທີ່ກ່ຽວຂ້ອງ.",
    placement: "top",
  },
];

export const serviceStandardDetailTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າລາຍລະອຽດມາດຕະຖານບໍລິການ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-standard-detail-toolbar"]',
    content: "ກັບຄືນ ຫຼື ເປີດຕົວຢ່າງ PDF.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-standard-detail-page-title"]',
    content: "ຊື່ມາດຕະຖານທີ່ທ່ານກຳລັງເບິ່ງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-standard-detail-content"]',
    content: "ລາຍລະອຽດ: ສິ່ງຄວນເຮັດ/ບໍ່ຄວນເຮັດ, ຕົວຢ່າງ ແລະ ກໍລະນີພິເສດ.",
    placement: "top",
  },
];

export const checklistExecutionTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ທີ່ນີ້ທ່ານກວດລາຍການໄດ້ໃນທີ່ດຽວ: ຊ້າຍເປັນລາຍການ, ຂວາເປັນຄວາມຄືບໜ້າ ແລະ ປຸ່ມບັນທຶກ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-checklist-detail-title"]',
    content: "ຫົວຂໍ້ ແລະ ວັນທີ່ຮອບກວດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-checklist-detail-meta"]',
    content: "ສະຖານະ, ຄວາມຖີ່ ແລະ ກຳນົດສົ່ງ (ຖ້າມີ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-checklist-detail-items"]',
    content: "ກົດເຄື່ອງຫມາຍຕໍ່ລາຍການ; ກຸ່ມຕາມຫົວຂໍ້ຍ່ອຍຖ້າຫົວຂໍ້ມີຕົວແບ່ງ | ຫຼື — .",
    placement: "top",
  },
  {
    target: '[data-tourid="training-checklist-detail-actions"]',
    content: "ບັນທຶກຮ່າງ, ສົ່ງວຽກ ແລະ ເລີ່ມຮອບໃໝ່ (ເມື່ອສຳເລັດແລ້ວ).",
    placement: "top",
  },
];

export const sopPdfPreviewTourSteps: Step[] = [
  {
    target: "body",
    content: "ໜ້າຕົວຢ່າງ PDF ສຳລັບ SOP. ໃຊ້ພິມເພື່ອບັນທຶກ ຫຼື ປະກອບເອກະສານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-sop-pdf-toolbar"]',
    content: "ກັບໄປລາຍລະອຽດ SOP ຫຼື ພິມໜ້ານີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-sop-pdf-page-title"]',
    content: "ຫົວຂໍ້ SOP ສຳລັບຕົວຢ່າງນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-sop-pdf-content"]',
    content: "ເນື້ອຫາທີ່ຈະສະແດງໃນການພິມ.",
    placement: "top",
  },
];

export const serviceStandardPdfPreviewTourSteps: Step[] = [
  {
    target: "body",
    content: "ໜ້າຕົວຢ່າງ PDF ສຳລັບມາດຕະຖານບໍລິການ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="training-standard-pdf-toolbar"]',
    content: "ກັບຄືນ ຫຼື ພິມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-standard-pdf-page-title"]',
    content: "ຊື່ມາດຕະຖານສຳລັບຕົວຢ່າງນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="training-standard-pdf-content"]',
    content: "ເນື້ອຫາມາດຕະຖານສຳລັບການພິມ.",
    placement: "top",
  },
];
